"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get packageInfo () {
        return packageInfo;
    },
    get packageVersion () {
        return packageVersion;
    }
});
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let packageInfo = {};
try {
    packageInfo = JSON.parse(_fs.default.readFileSync(_path.default.join(process.cwd(), 'node_modules', 'nocodb', 'package.json'), 'utf8'));
} catch (unused) {
    try {
        var _process_pkg;
        // check within executable
        packageInfo = JSON.parse(_fs.default.readFileSync(_path.default.join(_path.default.dirname((_process_pkg = process['pkg']) == null ? void 0 : _process_pkg['defaultEntrypoint']), 'node_modules', 'nocodb', 'package.json'), 'utf8'));
    } catch (unused) {
        try {
            packageInfo = JSON.parse(_fs.default.readFileSync(_path.default.join(process.cwd(), 'package.json'), 'utf8'));
        } catch (unused) {}
    }
}
const packageVersion = packageInfo == null ? void 0 : packageInfo.version;
